/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercises: NonNullable<unknown>, minutes: NonNullable<unknown> }} Quick_Workout_Review_SummaryInputs */

const en_us2_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} exercises · about ${i?.minutes} min`)
};

const pt_br2_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} exercícios · cerca de ${i?.minutes} min`)
};

const es_419_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} ejercicios · unos ${i?.minutes} min`)
};

const pt_pt2_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} exercícios · cerca de ${i?.minutes} min`)
};

const fr_fr2_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} exercices · environ ${i?.minutes} min`)
};

const de_de2_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} Übungen · etwa ${i?.minutes} min`)
};

const it_it2_quick_workout_review_summary = /** @type {(inputs: Quick_Workout_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercises} esercizi · circa ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "{exercises} exercises · about {minutes} min" |
*
* @param {Quick_Workout_Review_SummaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_review_summary = /** @type {((inputs: Quick_Workout_Review_SummaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Review_SummaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_review_summary(inputs)
	if (locale === "es-419") return es_419_quick_workout_review_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_review_summary(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_review_summary(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_review_summary(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_review_summary(inputs)
	return en_us2_quick_workout_review_summary(inputs)
});
export { quick_workout_review_summary as "quick-workout.review_summary" }